import { useState } from 'react';

/**
 * @description a hook that will be executed before the first mount of a component
 * it is just a copy of the useState hook, but renamed for more clarity of what we want to do with it
 */
export const useBeforeMount: (fn: () => void) => void = useState;
